export const SET_COMPONENT = 'SET_COMPONENT'
export const SET_PROPERTY = 'SET_PROPERTY'
export const SET_CURRENT_BEAN = 'SET_CURRENT_BEAN'
export const SET_CONDITIONS = 'SET_CONDITIONS'
export const SET_ALL_FIELDS = 'SET_ALL_FIELDS'

/** 前台 */
export const SET_FRONTEND = 'SET_FRONTEND'
export const SET_FRONTEND_GUIDE_CODE = 'SET_FRONTEND_GUIDE_CODE'
export const SET_LISTLAYOUT_STYLE = 'SET_LISTLAYOUT_STYLE'
export const SET_DETAILSLAYOUT_STYLE = 'SET_DETAILSLAYOUT_STYLE'
export const SET_SYSTEM_MODEULE_LIST = 'SET_SYSTEM_MODEULE_LIST'
export const SET_LANGUAGE_DATA_SET = 'SET_LANGUAGE_DATA_SET'
export const PER_DEP_LINKAGE = 'PER_DEP_LINKAGE'
export const SET_SUBFORM_REF_MAPPING = 'SET_SUBFORM_REF_MAPPING'
export const SET_SUBFORM_RELATION = 'SET_SUBFORM_RELATION'
export const SET_SUBFORM_BATCHUPDATE = 'SET_SUBFORM_BATCHUPDATE'
export const SET_PICKLIST_DEPEND_NEW = 'SET_PICKLIST_DEPEND_NEW'
export const SET_CLEAR_OICKLIST_FIELD = 'SET_CLEAR_OICKLIST_FIELD'
export const SET_CLEAR_DEPARTMENT_DATA = 'SET_CLEAR_DEPARTMENT_DATA'
export const SET_REPORT_MENU_UPDATE = 'SET_REPORT_MENU_UPDATE'
export const MULTITEXT_SET_COVER = 'MULTITEXT_SET_COVER'
export const SET_AUTH_BY_ROLE = 'SET_AUTH_BY_ROLE'
export const SET_USER_INFO = 'SET_USER_INFO'

/* *自定义报表 ******************************************/
export const SWITCH_CURRENT_BEAN = 'SWITCH_CURRENT_BEAN'
export const SWITCH_SOURCE_BEAN = 'SWITCH_SOURCE_BEAN'
export const SWITCH_SOURCE_LIST = 'SWITCH_SOURCE_LIST'
export const SET_DASH_ID = 'SET_DASH_ID'
export const CHANGE_CURRENT_BEAN = 'CHANGE_CURRENT_BEAN'
export const CHART_PAGE = 'CHART_PAGE'
export const SET_CURRENT_FIELD = 'SET_CURRENT_FIELD'
export const SET_IS_DRAG = 'SET_IS_DRAG'
// 新改版
export const SET_CURRENT_TYPE = 'SET_CURRENT_TYPE' // 当前使用的图表类型
export const SET_CHOOSE_BEAN = 'SET_CHOOSE_BEAN' // 当前bean
export const SET_CURRENT_FIELDS = 'SET_CURRENT_FIELDS' // 当前使用的字段
export const SET_CURRENT_CHART = 'SET_CURRENT_CHART' // 当前使用的字段
export const SET_CHART_OPTION = 'SET_CHART_OPTION' // 保存当前属性设置
export const SET_CHART_INDEX = 'SET_CHART_INDEX' //  设置当前索引
export const SET_ALL_CHART = 'SET_ALL_CHART' //  设置所有图标
export const SET_CURRENT_DA_ID = 'SET_CURRENT_DA_ID' //  设置当前ID
export const SET_CHART_CHANGE = 'SET_CHART_CHANGE' //  判断图表是否改变
export const SET_SOURCE = 'SET_SOURCE'
export const SET_IS_EMPTY = 'SET_IS_EMPTY'
export const SET_FROM_TO_MAIN = 'SET_FROM_TO_MAIN'
/** END ************************************************/

/* *邮件 *********************************************/
export const EMAIL_KEYWORD = 'EMAIL_KEYWORD' // 邮件搜索关键字
/* *邮件 *********************************************/

/* *备忘录 *********************************************/
export const MEMO_DIALOG_ISOPEN = 'MEMO_DIALOG_ISOPEN' // 备忘录内容
// export const MEMO_TITLE = 'MEMO_TITLE' // 备忘录title
// export const MEMO_PICURL = 'MEMO_PICURL' // 备忘录图片资源路径
// export const MEMO_ADDRESS = 'MEMO_ADDRESS' // 地址数据
// export const MEMO_ITEMS_ARR = 'MEMO_ITEMS_ARR' // 关联项目数组对象
// export const MEMO_SHARE_IDS = 'MEMO_SHARE_IDS' // 共享人员编号
// export const MEMO_REMIND_TIME = 'MEMO_REMIND_TIME' // 提醒时间
// export const MEMO_REMIND_STATUS = 'MEMO_REMIND_STATUS' // 是否仅提醒自己
/** END ************************************************/

/* *自定义模块 *********************************************/
export const ENABLE_LAYOUT = 'ENABLE_LAYOUT' // 未使用布局布局
export const CUSTOM_PAGE = 'CUSTOM_PAGE' // 自定义页面ID标识
export const CUSTOM_LAYOUT = 'CUSTOM_LAYOUT' // 布局
export const PREVIEW_LAYOUT = 'PREVIEW_LAYOUT' // 预览布局
export const DESIGN_CHANGE = 'DESIGN_CHANGE' // 设计变化
export const CUSTOM_APPEARANCE = 'CUSTOM_APPEARANCE' // 自定义外观
export const CHILD_CUSTOM_LAYOUT = 'CHILD_CUSTOM_LAYOUT' // 子页面布局
export const CHILD_UNUSED_LAYOUT = 'CHILD_UNUSED_LAYOUT' // 子页面未使用布局
export const APP_LSIT_LAYOUT = 'APP_LSIT_LAYOUT' // APP列表布局
export const CUSTOM_MODULE_LIST = 'CUSTOM_MODULE_LIST' // 自定义模块列表
export const SELECT_HIDE_FIELD = 'SELECT_HIDE_FIELD' // 选项隐藏字段
export const SELECT_SHOW_FIELD = 'SELECT_SHOW_FIELD' // 选项显示字段
export const LINKAGE_FIELDS_DATA = 'LINKAGE_FIELDS_DATA' // 联动数据
export const SIGNATURE_EMIT_EVENT = 'SIGNATURE_EMIT_EVENT' // 手写签名
export const TAB_SCREEN_DATA = 'TAB_SCREEN_DATA' // 页签筛选
export const UPDATE_CUSTOM_DETAIL = 'UPDATE_CUSTOM_DETAIL' // 更新自定义详情
export const UPDATE_CUSTOM_LIST = 'UPDATE_CUSTOM_LIST' // 更新自定义列表
export const SET_CHECK_EMPTY = 'SET_CHECK_EMPTY' // 清空选择项
export const CUSTOM_BATCH_LINKAGE = 'CUSTOM_BATCH_LINKAGE' // 批量联动
export const BUSINESS_FLOW_REFERENCE = 'BUSINESS_FLOW_REFERENCE' // 业务流程关联关系
export const UPDATE_REFERENCE_CREATE = 'UPDATE_REFERENCE_CREATE' // 业务流程关联关系
export const UPDATE_SUBFORM_REPEAT = 'UPDATE_SUBFORM_REPEAT' // 子表单查重设置
export const SET_HJC_CALLBACK_PHONE = 'SET_HJC_CALLBACK_PHONE' // 子表单查重设置
export const SET_MAIN_TO_SUBFORM_BATCHLINKAGE = 'SET_MAIN_TO_SUBFORM_BATCHLINKAGE' // 主表触发子表单联动
export const UPDATE_SUBFORM_STYLE = 'UPDATE_SUBFORM_STYLE'
export const SET_CUSTOM_APP_MODULE_DATA = 'SET_CUSTOM_APP_MODULE_DATA'
export const CLOUM_SCREEN_SET_DATA = 'CLOUM_SCREEN_SET_DATA'
export const CUSTOM_EVENT_UPDATE = 'CUSTOM_EVENT_UPDATE'
export const CUSTOM_SEND_REFERENCE = 'CUSTOM_SEND_REFERENCE'
/** END ************************************************/

/* *任务自定义 *********************************************/
export const SET_ALL_LAYOUT = 'SET_ALL_LAYOUT' // 总布局
export const SET_SINGLE_LAYOUT = 'SET_SINGLE_LAYOUT' // 单个布局single
export const SET_COMPONENT_FLAG = 'SET_COMPONENT_FLAG' //  单个布局标识
export const SET_UNUSE_COMPONENT = 'SET_UNUSE_COMPONENT' //  单个布局标识
export const SET_ENABLE_FIELDS = 'SET_ENABLE_FIELDS' // 使用的布局
export const SET_CURRENT_INDEX = 'SET_CURRENT_INDEX' // 当前编辑INDEX
export const SET_PREVIEW_LAYOUT = 'SET_PREVIEW_LAYOUT' // 预览的布局

/** END ************************************************/

/** 子表单设置 */
export const SET_WEBFORM_LAYOUT = 'SET_WEBFORM_LAYOUT' // 总布局
export const SET_WEBFOTM_ENABLE = 'SET_WEBFOTM_ENABLE' // 使用字段
export const SET_WEBFOTM_PROPS = 'SET_WEBFOTM_PROPS' // // 表单属性
export const SET_DISAB_FIELDS = 'SET_DISAB_FIELDS' // // 未使用字段
export const SET_PAGE_LAYOUT = 'SET_PAGE_LAYOUT' // 分页总布局
// export const SET_WEBFOTM_ENABLE = 'SET_WEBFOTM_ENABLE' //
/** END **********************************************/

/* *任务自定义 *********************************************/
export const PROJECT_STATUS = 'PROJECT_STATUS' // 项目状态
export const PROJECT_LAYOUT_CHANGE = 'PROJECT_LAYOUT_CHANGE' // 项目布局
export const M_C_A_SAVE_SUCCESS = 'M_C_A_SAVE_SUCCESS' // 备忘录，自定义，审批等新建保存
export const M_C_A_QUOTE_SUCCESS = 'M_C_A_QUOTE_SUCCESS' // 备忘录，自定义，审批等关联

/* *平台模版 *********************************************/
export const PLATFORM_TEMPLATE_LAYOUT = 'PLATFORM_TEMPLATE_LAYOUT' // 模块模版布局
export const COMMON_FIELDS = 'COMMON_FIELDS' // 常用字段
export const PREVIEW_COMMON_FIELDS = 'PREVIEW_COMMON_FIELDS' // 常用字段预览
export const PREVIEW_TEMPLATE_LAYOUT = 'PREVIEW_TEMPLATE_LAYOUT' // 布局字段预览
export const CUSTOM_APPEARANCE_NEW = 'CUSTOM_APPEARANCE_NEW' // 布局字段预览
/** END ************************************************/

/** 后台管理权限 *********************************************/
export const SET_COMMODITY = 'SET_COMMODITY' // 中央控制台 - 功能清单
export const SET_BACKAUTH = 'SET_BACKAUTH' // 后台管理权限
/** END ************************************************/

/* * 薪酬 *********************************************/
export const SET_SALARYSCHEME = 'SET_SALARYSCHEME' // 薪酬 salaryScheme
export const SALARY_POP_EVENT_DATA = 'SALARY_POP_EVENT_DATA' // 薪酬 salaryScheme
/** END ************************************************/

/* * 门户 *********************************************/
export const SET_WORKBENCH_SETTING = 'SET_WORKBENCH_SETTING' // 门户 布局
export const SET_WORKBENCH_LAYOUT = 'SET_WORKBENCH_LAYOUT' // 门户 布局
/** END ************************************************/

/* * OKR *********************************************/
export const OKR_REMINDER_CHANGE = 'OKR_REMINDER_CHANGE' // 提醒成员更新
export const OKR_DATE_TIME_CHANGE = 'OKR_DATE_TIME_CHANGE' // 时间变更(筛选和赋值)
export const OKR_DUIQI_REFERENCE_KR = 'OKR_DUIQI_REFERENCE_KR' // 对齐目标或者任务关联kr
export const OKR_X_X_CAHNGE = 'OKR_X_X_CAHNGE' // KR信心指数变更
export const OKR_ADD_EDIT_EVENT = 'OKR_ADD_EDIT_EVENT' // okr新增或者编辑完成后
export const PROGRESS_WEIGHT_CHANGE = 'PROGRESS_WEIGHT_CHANGE' // 权重和进度修改
export const OKR_CREATE_KR_TASK_EVENT = 'OKR_CREATE_KR_TASK_EVENT' // 创建kr或者kr任务的完成
/** END ************************************************/

/* * OKR *********************************************/
export const TARGET_SET_ROLE = 'TARGET_SET_ROLE' // 目标角色设置
export const TARGET_SET_ALIGN = 'TARGET_SET_ALIGN' // 设置对齐目标
export const TARGET_SET_CREATE = 'TARGET_SET_CREATE' // 新增目标
export const TARGET_MX_CY = 'TARGET_MX_CY' // 新增目标
export const TARGET_GW_MY_SCREEN = 'TARGET_GW_MY_SCREEN' // 岗位目标和我的目标筛选
export const TARGET_OKR_KR_WEIGHT = 'TARGET_OKR_KR_WEIGHT' // 目标或者kr的权重
export const TARGET_UPDATE_LIST = 'TARGET_UPDATE_LIST' // 更新列表
export const OKR_KR_DATA_CHANGE = 'OKR_KR_DATA_CHANGE' // 更新列表
/** END ************************************************/

export const SET_PERFORMANCE_SETTING = 'SET_PERFORMANCE_SETTING' // 考核设置

// 组织职级
export const ORG_POP_EVENT = 'ORG_POP_EVENT' // 弹窗时间回调

// 员工管理
export const SET_STAFF_STROE_DATA = 'SET_STAFF_STROE_DATA'
export const SET_ROSTER_SETTING = 'SET_ROSTER_SETTING'
export const SET_ROSTER_ROLE_DATA = 'SET_ROSTER_ROLE_DATA'

// 考勤管理
export const SET_ATTENDANCE_STROE_DATA = 'SET_ATTENDANCE_STROE_DATA'
export const SET_ATTENDANCE_ROLE_DATA = 'SET_ATTENDANCE_ROLE_DATA'

// 人才管理
export const SET_TANLENT_STROE_DATA = 'SET_TANLENT_STROE_DATA'
export const SET_TALENT_ROLE_DATA = 'SET_TALENT_ROLE_DATA'
